import React, {PropsWithChildren} from 'react';
import ReactDOM from 'react-dom';
import './ArrPopoutPanel.scss';

// Types Definitions
// ----------------------------------
type PopoutWindowPortalProps = PropsWithChildren<{
  node: HTMLElement | null;
}>;

// ----------------------------------
// PopoutWindowPortal Component
// ----------------------------------
const PopoutWindowPortal: React.FC<PopoutWindowPortalProps> = ({
  children,
  node,
}) => {
  if (!node) {
    return null;
  }

  return ReactDOM.createPortal(children, node);
};

export {PopoutWindowPortal};
export default PopoutWindowPortal;
